module.exports = __webpack_public_path__ + "static/iynk-own-79dbb1512a73d2947fbc72f159826f82.mp4";